import { render, staticRenderFns } from "./loading-game.vue?vue&type=template&id=13918c9d&scoped=true"
import script from "./loading-game.vue?vue&type=script&lang=js"
export * from "./loading-game.vue?vue&type=script&lang=js"
import style0 from "./loading-game.vue?vue&type=style&index=0&id=13918c9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13918c9d",
  null
  
)

export default component.exports